export default {"src":"/_next/static/media/realEstateLogo3.500416bd.svg","height":74,"width":116,"blurWidth":0,"blurHeight":0};